import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ['count'];
  }

  static values = {
    included: String
  }

  connect() {
    this.updateState();
  }

  updateState() {
    this.includedValue = this.selectedCheckboxes.join(" ");
  }

  get selectedCheckboxes() {
    return this.checkboxes.filter((c) => c.checked).map(c => c.name);
  }

  get checkboxes() {
    return new Array(...this.element.querySelectorAll("input[type=checkbox]"));
  }
}
